import styled from "styled-components";

export const AuthorizationManagementWrapper = styled.div`
  background: #292b2f;
  border: 1px solid #343538;
  border-radius: 4px;
  min-height: 100%;
`;
